/* unplugin-vue-components disabled */import script from "./SearchForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchForm.vue?vue&type=script&setup=true&lang=ts"

import "./SearchForm.vue?vue&type=style&index=0&id=1f3af846&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f3af846"]])

export default __exports__